import { Button, css, Mode, styled, TextInput } from 'canoe';

import { StyledToggle, StyledValueBox } from 'craft/containers/Toolbox/components/StyledComponents';

export const FallbacksContainer = styled.div<{ mode?: Mode }>`
  ${({ theme }) => css`
    margin-top: ${theme.spaces.xs};
  `}
`;

export const FallbackFieldsWrapper = styled.div`
  ${({ theme }) => css`
    margin-top: ${theme.spaces.xs};
  `}
`;

export const FallbacksToggle = styled(StyledToggle)`
  ${({ theme }) => css`
    padding: 0 ${theme.spaces.xs};
  `}
`;

export const FallbacksToggleWrapper = styled(StyledValueBox)`
  ${({ theme }) => css`
    background-color: ${theme.colors.GlitterGrayL10};

    // value box label
    > div:first-child {
      font-weight: 300;
      color: ${theme.colors.OnyxGrayD10};
    }
  `}
`;

export const MediaValueBox = styled(StyledValueBox)`
  // value box label
  > div:first-child {
    font-weight: 300;
  }
`;

export const MediaButton = styled(Button)`
  ${({ theme }) => css`
    margin: ${theme.spaces.xs} 0 0 !important;
    background-color: ${theme.colors.OnyxGrayL30};
    border-color: transparent;
    color: ${theme.colors.GlitterGrayL30};
    ${theme.fonts.small};
  `}
`;

export const FallbacksInputToolbar = styled(TextInput)<{
  prefix?: string;
  isFirst?: boolean;
  hasError?: boolean;
}>`
  ${({ theme, prefix, isFirst, hasError }) => css`
    height: 32px;
    font-size: ${theme.fonts.small.fontSize};

    ${
      prefix &&
      css`
        padding-left: ${theme.spaces.xxs};

        + label {
          height: 32px;
          font-size: ${theme.fonts.small.fontSize};
          padding: ${theme.spaces.xxs} ${theme.spaces.xs} ${theme.spaces.xxs} ${theme.spaces.xs};

          ${!isFirst &&
          css`
            margin-top: ${theme.spaces.xs};
          `}

          ${hasError &&
          css`
            outline: 1px solid ${theme.colors.Danger};
          `}
        }
      `
    }

    ${
      !isFirst &&
      css`
        margin-top: ${theme.spaces.xs};
      `
    }

    ${
      hasError &&
      css`
        outline: 1px solid ${theme.colors.Danger};
      `
    }
  `}
`;
